import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage from '../../components/LegalPage';

const Teilnahmebedingungen = () => (
  <LegalPage title="Teilnahmebedingungen">
    <p><strong>Stand:</strong> {new Date().getFullYear()}</p>

    <h2>1. Veranstalter</h2>
    <p>
      Das Tippspiel wird von tivoli12 betrieben.
      Verbindliche Anbieterinformationen findest du im{' '}
      <a href="https://tivoli12.at/impressum" target="_blank" rel="noopener noreferrer">Impressum</a>.
    </p>

    <h2>2. Teilnahme</h2>
    <ul>
      <li>Teilnahme ist kostenlos und setzt eine Registrierung voraus.</li>
      <li>Pro Person ist nur ein Benutzerkonto zulässig.</li>
      <li>Mitarbeiterinnen und Mitarbeiter von tivoli12 dürfen am Tippspiel teilnehmen; von der Vergabe von Gewinnen und Preisen sind sie ausgeschlossen (siehe Abschnitt 3).</li>
      <li>Tipps müssen vor Ablauf der jeweiligen Deadline abgegeben werden.</li>
      <li>Der Veranstalter kann Teilnehmer bei Manipulation, Mehrfachkonten oder Missbrauch ausschließen.</li>
    </ul>

    <h2>3. Gewinn-Disclaimer / Kein Glücksspiel</h2>
    <p>
      <strong>Dieses Tippspiel ist ein Fan-Spiel zur Unterhaltung.</strong> Es handelt sich nicht um ein
      gewerbliches Glücksspiel im Sinne des österreichischen Glücksspielgesetzes, sofern nicht ausdrücklich
      anders kommuniziert.
    </p>
    <ul>
      <li>
        <strong>Mitarbeiterinnen und Mitarbeiter von tivoli12</strong> sind von der Vergabe sämtlicher Gewinne und Preise
        ausgeschlossen, unabhängig von ihrer Platzierung in der Rangliste. Eine Teilnahme am Tippspiel ist ihnen dennoch
        ausdrücklich gestattet.
      </li>
      <li>Es werden <strong>keine Geldgewinne</strong> ausgespielt, sofern nicht in einer gesonderten Aktion ausdrücklich angekündigt.</li>
      <li>Es besteht <strong>kein Rechtsanspruch</strong> auf Preise, Anerkennung oder bestimmte Auswertungen.</li>
      <li>Etwaige Sach- oder symbolische Preise (z. B. Fan-Artikel) werden – falls vorgesehen – separat bekannt gegeben; ein Barauszahlungsanspruch besteht nicht.</li>
      <li>Der Veranstalter behält sich vor, Auswertungen zu korrigieren, wenn Ergebnisse nachträglich geändert werden (z. B. durch offizielle Spielberichte).</li>
    </ul>

    <h2>4. Auswertung &amp; Rangliste</h2>
    <p>
      Punkte werden automatisch nach den veröffentlichten Spielergebnissen vergeben. Die Rangliste dient
      ausschließlich dem Vergleich unter Teilnehmerinnen und Teilnehmern. Technische Störungen können
      zu Verzögerungen führen; ein Anspruch auf fehlerfreie Echtzeit-Auswertung besteht nicht.
    </p>

    <h2>5. Haftung</h2>
    <p>
      Der Veranstalter haftet nur bei Vorsatz oder grober Fahrlässigkeit. Für leichte Fahrlässigkeit
      haftet der Veranstalter nur bei Verletzung wesentlicher Vertragspflichten und begrenzt auf den
      typischerweise vorhersehbaren Schaden.
    </p>

    <h2>6. Datenschutz</h2>
    <p>
      Informationen zur Verarbeitung personenbezogener Daten findest du in der{' '}
      <Link to="/datenschutz" className="text-primary-light hover:underline">Datenschutzerklärung</Link>.
    </p>

    <h2>7. Änderungen &amp; Beendigung</h2>
    <p>
      Der Veranstalter kann diese Bedingungen, das Reglement oder das Tippspiel jederzeit anpassen oder
      beenden. Bei wesentlichen Änderungen werden registrierte Nutzer nach Möglichkeit informiert.
    </p>
  </LegalPage>
);

export default Teilnahmebedingungen;
